import Vue from 'vue'
import moment from 'moment'
import 'moment/locale/sr'
import 'moment/locale/en-in'

moment.locale('sr')

Vue.prototype.$moment = moment
